import {DynamicLoader} from "@mecatran/dynamicloader"



function loadGoogleMaps(){
    var _url = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBNicnjtNzxuikok8NSW5uUR2xjGzHaIPE"
    var dynamicLoader = new DynamicLoader([_url]);
    return dynamicLoader.loadAll()
}

export function mapInit(){
    return loadGoogleMaps();
}

